import { Gift, Trash2 } from 'lucide-react'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setPackageJson } from '../../redux/Actions/BillingAction'
import MyInput from '../../components/MyComponent/MyInput'
import { calculateBillSummary } from '../../utils/utils'
import { searchPackage } from '../../constant/Constant'
import MySearchableSelect from '../../components/MyComponent/BillingSearchableSelect'

export const PackageSection = () => {
    const BillingReducer = useSelector((state) => state.BillingReducer)
    const dispatch = useDispatch()
    const updatePackage = (type, value, index) => {
        let oldData = [...BillingReducer?.selectedPackages];
        if (type === "addPackage") {
            oldData[index] = { ...oldData[index], package: value, price: value.totalPrice, total: value.totalPrice }
        }
        else if (type === "changePrice") {
            if (value !== '' && !/^(?:[0-9]+(?:\.[0-9]*)?)?$/.test(value)) return;
            oldData[index] = { ...oldData[index], price: value, total: value }
        }
        else if (type === "removePackage") {
            oldData = [...oldData.slice(0, index), ...oldData.slice(index + 1)]
        }
        dispatch(setPackageJson(oldData))
        const updatedBillingReducer = { ...BillingReducer, selectedPackages: oldData };
        calculateBillSummary(updatedBillingReducer, dispatch);
    };
    return (
        <div>   {(BillingReducer?.selectedPackages || []).length > 0 && (
            <div className="bg-white rounded-xl shadow-lg p-6">
                <div className="flex items-center gap-2 mb-4">
                    <Gift className="text-orange-600" size={20} />
                    <h2 className="text-xl font-semibold text-gray-800">Package</h2>
                </div>
                {BillingReducer?.selectedPackages?.map((pkg, index) => (
                    <div key={pkg.id} className="grid grid-cols-3 gap-4 mb-4 items-end">
                        <div>
                            <MySearchableSelect giveFullElement={true} api={searchPackage} optionLable="packageName" onChange={(value) => updatePackage("addPackage", value, index)} title="Search Service" placeholder={"Select Service"} />
                        </div>
                        <div>
                            <MyInput title={'Price'} value={pkg.price || ""} onChange={(e) => updatePackage("changePrice", parseFloat(e.target.value) || 0, index)} type="number" />
                        </div>
                        <div className="flex items-center gap-2">
                            <span className="text-lg font-semibold text-gray-800">₹{pkg.total || 0}</span>
                            <button onClick={() => updatePackage("removePackage", false, index)} className="text-red-500 hover:text-red-700">
                                <Trash2 size={16} />
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        )}</div>
    )
}
